<template>
  <v-dialog :model-value="modelValue" max-width="460" persistent @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title class="text-h6 d-flex align-center">
        <v-icon left>mdi-vector-combine</v-icon>
        合成为操作记录
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <div class="text-caption text-grey mb-3">
          将当前组合按顺序合成为一条连续的动作，并保存为新的操作记录。
          动作内较短的舵机会自动补足步长以保持同步，动作之间的间隔将以“保持不动”填充。
        </div>
        <v-text-field
          :model-value="name"
          label="合成后的操作名称"
          variant="outlined"
          density="comfortable"
          hide-details
          autofocus
          @update:model-value="$emit('update:name', $event)"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-3">
        <v-btn variant="outlined" :disabled="combining" @click="$emit('update:modelValue', false)">取消</v-btn>
        <v-spacer />
        <v-btn
          color="deep-purple"
          variant="flat"
          :loading="combining"
          :disabled="!name || !name.trim()"
          @click="$emit('confirm')"
        >
          <v-icon left>mdi-content-save</v-icon>生成记录
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
defineProps({
  modelValue: { type: Boolean, default: false },
  name: { type: String, default: '' },
  combining: { type: Boolean, default: false }
})
defineEmits(['update:modelValue', 'update:name', 'confirm'])
</script>
